import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useInView } from 'react-intersection-observer';
import { useAlgoliaAnalytics } from '@grandvisionhq/analytics';
import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { MediaQuery } from '@grandvisionhq/common';
import { getAttrValue } from '@grandvisionhq/utils';
import 'classnames';
import '@grandvisionhq/fun-products';
import '@grandvisionhq/lib-visuals';
import '@grandvisionhq/state';
import { useProductDetailContext } from './Context/ProductDetailContext.js';
import '@grandvisionhq/svc-monetate';
import '@grandvisionhq/inventory';
import '@grandvisionhq/reviews';
import '@grandvisionhq/carts-v2';
import { WebPageAnalytics } from './Components/WebPageAnalytics/WebPageAnalytics.js';
import { LensesContainer } from './Lenses/LensesContainer.js';
import { LensBundleProvider } from './Lenses/LensBundles/context.js';
import { SolutionsContainer } from './Solutions/SolutionsContainer.js';
import { SolutionsEcommProvider } from './Solutions/context/SolutionsEcommContext.js';

const ProductDetail = ({ deliveryResolverFactory  })=>{
    const { activeSku , activeVariant , product , productType  } = useProductDetailContext();
    const isMobile = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    const algoliaAnalytics = useAlgoliaAnalytics();
    const { queryId: storedQueryId  } = (algoliaAnalytics === null || algoliaAnalytics === void 0 ? void 0 : algoliaAnalytics.algoliaAnalyticsData) || {};
    const algoliaQueryId = React.useRef(storedQueryId);
    const containerRef = React.useRef(null);
    const [ctaRef, ctaInview] = useInView();
    const showStickyButton = isMobile && !ctaInview;
    React.useEffect(()=>{
        if (storedQueryId) {
            algoliaQueryId.current = storedQueryId;
        }
    }, [
        storedQueryId
    ]);
    React.useEffect(()=>{
        // make sure the queryId will not be used when a user doesn't click the CTA. For example: user clicks on a product suggestion and clicks the CTA there.
        algoliaQueryId.current && algoliaAnalytics.clearQueryId();
    }, [
        algoliaQueryId.current
    ]);
    const ean1 = React.useMemo(()=>{
        const ean = getAttrValue(product.masterVariant, 'supplierEAN');
        if (typeof ean === 'string') {
            return ean;
        }
        return undefined;
    }, [
        product
    ]);
    /**
   * Sends a conversion event to Algolia
   */ const handleConversionEvent = React.useCallback(()=>{
        algoliaAnalytics.handleConversionEvent(activeSku, algoliaQueryId.current);
    }, [
        activeSku,
        algoliaAnalytics
    ]);
    if (!productType || !activeVariant) {
        return null;
    }
    const commonProps = {
        activeSku,
        ean: ean1,
        addToCartRef: ctaRef,
        product,
        showStickyButton,
        onCTAClick: handleConversionEvent,
        handleConversionEvent
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "product-detail"
    }, /*#__PURE__*/ React.createElement("div", {
        ref: containerRef,
        className: "site-container product-detail__container"
    }, CommerceToolsApi.isLenses(activeVariant) && /*#__PURE__*/ React.createElement(LensBundleProvider, null, /*#__PURE__*/ React.createElement(LensesContainer, swcHelpers.extends({}, commonProps, {
        variant: activeVariant,
        /**
               * Stock configurations props
               */ deliveryResolverFactory: deliveryResolverFactory
    }))) || CommerceToolsApi.isSolutions(activeVariant) && /*#__PURE__*/ React.createElement(SolutionsEcommProvider, null, /*#__PURE__*/ React.createElement(SolutionsContainer, swcHelpers.extends({}, commonProps, {
        variant: activeVariant
    })))), /*#__PURE__*/ React.createElement(WebPageAnalytics, null));
};

export { ProductDetail };
//# sourceMappingURL=ProductDetail.js.map
